import { appContent } from '@/mocks/homepage';

export default function AppSection() {
  return (
    <section id="app" className="py-16 md:py-20 bg-background-50">
      <div className="max-w-7xl mx-auto px-4 md:px-6">
        <div className="flex flex-col lg:flex-row items-center gap-10 lg:gap-20">
          {/* App Mockup */}
          <div className="w-full lg:w-2/5 flex justify-center">
            <div className="relative w-[240px] h-[480px] rounded-[2rem] overflow-hidden bg-background-100 border-[6px] border-background-300 flex-shrink-0">
              <img
                src={appContent.img}
                alt={appContent.alt}
                className="w-full h-full object-cover"
                loading="lazy"
              />
            </div>
          </div>

          {/* Content */}
          <div className="w-full lg:w-3/5 text-center lg:text-left">
            <h2 className="text-2xl md:text-3xl font-heading text-foreground-950 mb-3">
              {appContent.title}
            </h2>
            <p className="text-primary-500 font-medium mb-4">{appContent.subtitle}</p>
            <p className="text-sm text-foreground-600 leading-relaxed mb-8 max-w-md lg:max-w-none">
              {appContent.desc}
            </p>

            {/* Features grid */}
            <div className="grid grid-cols-2 sm:grid-cols-3 gap-3 mb-8">
              {appContent.features.map((feat, idx) => (
                <div key={idx} className="flex items-center gap-2 text-xs text-foreground-600">
                  <div className="w-5 h-5 flex items-center justify-center rounded-full bg-accent-100 text-accent-600 flex-shrink-0">
                    <i className="ri-check-line text-sm"></i>
                  </div>
                  {feat}
                </div>
              ))}
            </div>

            {/* Download buttons */}
            <div className="flex flex-col sm:flex-row items-center justify-center lg:justify-start gap-3">
              <a
                href="#app"
                onClick={(e) => e.preventDefault()}
                className="w-full sm:w-auto inline-flex items-center justify-center gap-2 px-6 py-3 bg-foreground-900 text-background-50 rounded-full text-sm font-medium hover:bg-foreground-800 transition-colors duration-200 whitespace-nowrap cursor-pointer"
              >
                <i className="ri-apple-fill text-base"></i>
                App Store 下载
              </a>
              <a
                href="#app"
                onClick={(e) => e.preventDefault()}
                className="w-full sm:w-auto inline-flex items-center justify-center gap-2 px-6 py-3 border border-foreground-300 text-foreground-700 rounded-full text-sm font-medium hover:border-foreground-500 transition-colors duration-200 whitespace-nowrap cursor-pointer"
              >
                <i className="ri-google-play-fill text-base"></i>
                Google Play 下载
              </a>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}